import { c as _c } from "react/compiler-runtime";
import { m } from 'framer-motion';
import { varAlpha } from 'minimal-shared/utils';
import Box from '@mui/material/Box';
import { RouterLink } from 'src/routes/components';
import { CONFIG } from 'src/global-config';
import { varTap, varHover, transitionTap } from 'src/components/animate';

// ----------------------------------------------------------------------

export function NavItemDashboard(t0) {
  const $ = _c(16);
  let other;
  let path;
  let sx;
  if ($[0] !== t0) {
    ({
      path,
      sx,
      ...other
    } = t0);
    $[0] = t0;
    $[1] = other;
    $[2] = path;
    $[3] = sx;
  } else {
    other = $[1];
    path = $[2];
    sx = $[3];
  }
  let t1;
  if ($[4] !== sx) {
    t1 = Array.isArray(sx) ? sx : [sx];
    $[4] = sx;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== t1) {
    t2 = [_temp, ...t1];
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = varTap(0.98);
    t4 = varHover(1.02);
    $[8] = t3;
    $[9] = t4;
  } else {
    t3 = $[8];
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = transitionTap();
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Box component={m.img} whileTap={t3} whileHover={t4} alt="Dashboard illustration" transition={t5} src={`${CONFIG.assetsDir}/assets/illustrations/illustration-dashboard.webp`} sx={{
      width: 640,
      objectFit: "cover",
      aspectRatio: "4/3"
    }} />;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== other || $[13] !== path || $[14] !== t2) {
    t7 = <Box href={path} component={RouterLink} sx={t2} {...other}>{t6}</Box>;
    $[12] = other;
    $[13] = path;
    $[14] = t2;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}
function _temp(theme) {
  return {
    height: 360,
    display: "grid",
    borderRadius: 1.5,
    placeItems: "center",
    px: {
      md: 3,
      lg: 10
    },
    color: "text.disabled",
    backgroundColor: "background.neutral",
    transition: theme.transitions.create("background-color", {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.sharp
    }),
    "&:hover": {
      backgroundColor: varAlpha(theme.vars.palette.grey["500Channel"], 0.12)
    }
  };
}